/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiUsers } from '../../models/api-users';
import { KeyType } from '../../models/key-type';

export interface GetApiKeysForOrganization$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function getApiKeysForOrganization(http: HttpClient, rootUrl: string, params: GetApiKeysForOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiUsers>> {
  const rb = new RequestBuilder(rootUrl, getApiKeysForOrganization.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiUsers>;
    })
  );
}

getApiKeysForOrganization.PATH = '/administration/organizations/{organizationKey}/api-keys';
